import { useState } from "react";

import { useOnBlock } from "./useOnBlock";
import { useRpcRequest } from "./useRpcRequest";

interface SimulatedTimeState {
  timestamp: number | null;
  blockNumber: bigint | undefined;
}

export function useSimulatedTime(): SimulatedTimeState {
  const { request } = useRpcRequest();
  const [timestamp, setTimestamp] = useState<number | null>(null);

  const blockNumber = useOnBlock(async () => {
    try {
      const block = (await request("eth_getBlockByNumber", [
        "latest",
        false,
      ])) as { timestamp?: string } | null;
      if (block?.timestamp) {
        setTimestamp(parseInt(block.timestamp, 16));
      }
    } catch {
      // ignore fetch errors
    }
  });

  return { timestamp, blockNumber };
}
